///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespace
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.datatables = abcsetup.datatables || {};
abcsetup.datatables.yajra = abcsetup.datatables.yajra || {};



///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.datatables.yajra = {
    filter_button: null,
    filter_timeout: null,

    init: function (table) {
        table = $('#' + table);
        table.attr('width', '100%');
        let tableWrapper = table.closest('.dataTables_wrapper');

        // Move the export buttons
        abcsetup.datatables.buttons.init(table);

        // Apply additional events to the table reset button
        this._resetTable(tableWrapper, table);

        // Apply the customization to the colvis plugin
        this._colvisFiltering();

        // Apply the column filtering
        abcsetup.datatables.search.init(table);

        abcsetup.datatables.yajra.loadDeferredTable(table);

        // Global tab click event listener
        $('button[data-toggle="tab"]').on('shown.bs.tab', function (event) {
            $('table.datatable:visible').each(function () {
                abcsetup.datatables.yajra.loadDeferredTable($(this));
            });
        });

        // Global modal shown event listener
        $('.modal').on('shown.bs.modal', function () {
            $('table.datatable:visible').each(function () {
                abcsetup.datatables.yajra.loadDeferredTable($(this));
            });
        });
    },

    /**
     * initComplete callback function from DataTables
     *
     * @param {*} settings
     * @param {*} json
     */
    initComplete: function(table, config) {
        // We just init a datatable that should be used client-side
        if (config['clientSide']) {
            config['clientSide'] = false;
            config['serverSide'] = false;
            config['ajax'] = null;

            // Reset stateSave if necessary
            if (config['resetStateSave'] == true) {
                config['stateSave'] = true;
            }

            $('#' + table).DataTable().destroy();
            $('#' + table).DataTable(config);
            abcsetup.datatables.yajra.init(table);
        }

        // Fix Autocomplete of sap_num on Unsolicited Bids view
        abcsetup.select2.init();
    },

    /**
     * Datatable drawCallback
     *
     * @param {*} table
     */
    drawCallback: function(table) {
        table = $('#' + table);

        let dtTable = table.DataTable();

        // Update datatable badge (if it's available)
        let id = table.attr('id').replace('app_data_tables_', '') + '_badge';
        console.log('Looking for datatable badge: ' + id);
        abcsetup.dashboard.setBadge($('#' + id), dtTable.page.info().recordsTotal);
        table.attr('data-total-records', dtTable.page.info().recordsTotal);

        abcsetup.loadRouteJS('tableDrawCallback', table.attr('id'));
    },

    /**
     * Apply additional events to the table reset button
     *
     * @param {*} tableWrapper
     * @param {*} table
     */
    _resetTable: function(tableWrapper, table) {
        tableWrapper.find('.buttons-reset').bind('click', function () {
            abcsetup.blockUI(true);

            // Make all columns visible again
            table.DataTable().columns().visible(true, false);
            $('.tooltips, .btn[title]').tooltip('hide');

            // Reset col re-ordering?
            //table.DataTable().colReorder.reset();

            // Reset DT stateSave
            table.DataTable().state.clear();

            table.DataTable().search('');
            table.DataTable().columns().search('');

            // Reset the dropdown filter buttons
            tableWrapper.find('th.filtered .datatable-column-filter-btn.active').data('filter', '').removeClass('active');
            tableWrapper.find('th.filtered').removeClass('filtered');
            abcsetup.unblockUI();
        });
    },

    /**
     * Apply the customization to the colvis plugin
     *
     * @param {*} table
     */
    _colvisFiltering: function() {
        // Apply bootstrap tooltips to the colvis buttons
        $('button.buttons-collection').tooltip({
            boundary: 'window',
        });

        // Show/Hide All clicked
        $('button.buttons-collection').on('click', function () {
            $('.dt-button.dropdown-item:first-child').off('click').on('click', function () {
                /* Redefining the table here because on views with multiple tables in horizontally tabbed views,
                 sometimes the table previously being passed in was not the correct one */
                let table = $(this).closest('.dataTables_wrapper').find('table.datatable');
                let dropdown = $(this).parent();
                let total = dropdown.find('.dt-button.buttons-columnVisibility').length;
                let active = dropdown.find('.dt-button.dropdown-item.active').length;

                // Show all columns
                if (active < total) {
                    table.DataTable().columns().visible(true, false);
                    dropdown.find('.dt-button.buttons-columnVisibility').addClass('active');

                    // Hide all columns
                } else {
                    table.DataTable().columns().visible(false, false);
                    dropdown.find('.dt-button.buttons-columnVisibility').removeClass('active');
                }

                // Hide the .removeCol columns
                table.DataTable().columns('.removeCol').each(function (index) {
                    if (this.visible()) {
                        this.visible(false, false);
                    }
                });
            });
        });
    },

    /**
     * Load a datatable with deferred loading
     *
     * @param {*} table
     */
    loadDeferredTable: function (table) {
        let badge_id = table.attr('id');
        badge_id = badge_id ? badge_id.replace('app_data_tables_', '') + '_badge' : null;

        // Check if we have any badge/counts to show, in which case we need to load the datatable
        if (badge_id && $('#' + badge_id).length > 0) {
            console.log('Force load deferred datatable: ' + table.attr('id'));
            abcsetup.datatables.yajra.performDeferredLoad(table);

        // Defer loading until the table is visible
        } else {
            table.onVisible(function($el) {
                abcsetup.datatables.yajra.performDeferredLoad($el);
            });
        }
    },

    /**
     * Perform the deferred load of a datatable
     *
     * @param {*} table
     */
    performDeferredLoad: function (table) {
        // Check if the datatable is already initialized
        const DataTable = window.LaravelDataTables && window.LaravelDataTables[table.attr('id')]
            ? window.LaravelDataTables[table.attr('id')]
            : null;

        if (DataTable && DataTable.data().any() === false && !table.hasClass('deferred-loaded')) {
            const settings = DataTable.settings()[0];
            table.addClass('deferred-loaded');

            if (settings.oInit.deferLoading === 0) {
                console.log('Loading deffered datatable: ' + table.attr('id') );
                // abcsetup.blockUI(true);
                table.find('td.dataTables_empty').html('<i><b>Loading...</b></i>');
                DataTable.ajax.reload();

                if (table.attr('style').indexOf('width: 0px') > -1) {
                    table.css('width', '');
                }

                table.trigger('resize');
            }
        }
    },
};
